import { AttributeType } from "../../../clients/Purchaser/Attributes";
import { Input, stopKeyPropagation } from "../../DesignSystem";
import type { PhoneAttributeFilter, SetAttributeFilter } from "../types";
import SetFilterItems from "./SetFilterItems";
import { useContainsSearch } from "./useContainsSearch";

type PhoneAttributeFilterSubmenuProps = {
    attributeId: number;
    currentFilter?: PhoneAttributeFilter;
    setAttributeFilter: SetAttributeFilter;
};

function PhoneAttributeFilterSubmenu({ attributeId, currentFilter, setAttributeFilter }: PhoneAttributeFilterSubmenuProps) {
    // "Contains" query. The backend does the fuzzy substring match.
    const [search, setSearch] = useContainsSearch({ type: AttributeType.PHONE, attributeId, currentValue: currentFilter?.value, setAttributeFilter });

    return (
        <>
            <Input
                placeholder="Enter a phone number"
                value={search}
                autoFocus
                onChange={e => setSearch(e.target.value)}
                inputContainerClasses="mb-1 w-full"
                className="w-full"
                onKeyDown={stopKeyPropagation}
            />
            {/* Picking a set/not-set option replaces any contains query. */}
            <SetFilterItems
                type={AttributeType.PHONE}
                attributeId={attributeId}
                currentSet={currentFilter?.set}
                setAttributeFilter={setAttributeFilter}
                onPick={() => setSearch("")}
            />
        </>
    );
}

export default PhoneAttributeFilterSubmenu;
